export default "__VITE_ASSET__DEDi5gM1__"